var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.list.length > 0 ? _c('div', {
    staticClass: "history",
    style: {
      borderRadius: _vm.borderRadius
    }
  }, _vm._l(_vm.list, function (el) {
    return _c('RadioElement', {
      key: el.value,
      staticClass: "history__el",
      class: {
        history__el_active: _vm.isChecked(_vm.modelValue, el.value)
      },
      attrs: {
        "value": el.value,
        "name": el.name,
        "checked": _vm.isChecked(_vm.modelValue, el.value)
      },
      on: {
        "change": function ($event) {
          return _vm.emit('change', el);
        }
      }
    }, [_vm._t("default", function () {
      return [_vm._v("\n      " + _vm._s(el.value) + "\n    ")];
    }, {
      "el": el
    })], 2);
  }), 1) : _c('div', {
    staticClass: "p grey-text"
  }, [_vm._v("\n  " + _vm._s(_vm.emptyText) + "\n")]);
}
var staticRenderFns = []

export { render, staticRenderFns }